module.exports = __webpack_public_path__ + "img/unmute.4b0d9d0c.svg";